import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import { FuseAnimate, TextFieldFormsy} from '@fuse';
import { DialogContent, CircularProgress, Dialog, Icon, InputAdornment, Card, CardContent, Hidden, Grid, Button, Typography, FormControlLabel, DialogActions, DialogTitle, List, ListItem, Checkbox, Paper, IconButton } from '@material-ui/core';

import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as Actions from 'store/actions';
import Formsy from 'formsy-react';
import classNames from 'classnames';

import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

import green from '@material-ui/core/colors/green';

const styles = theme => ({
    layoutRoot: {},
    success: {
        backgroundColor: green[600],
    },
    root: {
        color : theme.palette.primary.contrastText
    },
    icon : {
        marginBottom: '-6px'
    },
    loadingMasuk: {
        position: 'absolute',
        width: '100%',
        bottom: 0,
        height: 2
    },
    hut: {
        position: 'absolute',
        top: 24,
        right: 24,
        maxWidth: 74
    }
});

class Login extends Component {

    state = {
        error: null,
        isLoaded: false,
        namaPengguna: 'Khalid',
        bottom: false,
        ListMenu: null,
        email: null,
        canSubmit: true,
        loading_besar: false,
        pesan_kesalahan: false,
        pesan_ganda: false,
        pesan_tidak_ada_yang_dipilih: false,
        pesan_berhasil: false,
        pesan_gagal: false,
        routeParams: {
            // peran_id: JSON.parse(localStorage.getItem('user')).peran_id,
            // token: localStorage.getItem('jwt_token')
            media_id: localStorage.getItem('tipe_app')
        },
        disableButton: false,
        pilihanGanda: {},
        showPassword: false
    };

    goTolink = (url) => {
        this.props.history.push(url);
        // alert('oke ganti');
    };

    componentDidMount = () => {
        this.props.setJudul("Login Pengguna");
        let split1 = window.location.href.split("?")[1];
        let split3 = null;
        
        if(typeof(split1) !== 'undefined'){
            let split2 = split1.split("&")[0];

            if(typeof(split2) !== 'undefined'){
                split3 = split2.split("=")[1];
            }
        }

        console.log(split3);

        if(split3){
        // if(split3){
            if(Number(localStorage.getItem('tipe_app')) === 1 && Number(localStorage.getItem('online')) === 1){

                // console.log( localStorage.getItem('access_token') );
    
                if((localStorage.getItem('access_token') === null || localStorage.getItem('access_token') === '') && split3){
                    fetch(localStorage.getItem('api_domain')+'/api/getTokenSSO?code='+split3,{
                    // fetch('https://id.hub.kemdikbud.go.id/sso/token',{
                        method: 'post'
                    })
                    .then(res => res.json())
                    .then(
                    (result) => {
                        // console.log(result.error);
                        if(typeof(result.access_token) !== 'undefined'){
                            localStorage.setItem('access_token', result.access_token);
                            localStorage.setItem('refresh_token', result.refresh_token);
    
                            fetch(localStorage.getItem('api_domain')+'/api/getProfileSSO?access_token='+localStorage.getItem('access_token'),{
                                method: 'post'
                            })
                            .then(res => res.json())
                            .then(
                            (result) => {
                                // console.log(JSON.stringify(result));
                                result.email = result.username;
                                result.bidang_studi_id = result.kode_wilayah.trim();

                                localStorage.setItem('user', JSON.stringify(result));
                                window.location.href="/";
                            });
                        }
                    });
                }else if(split3){
                    fetch(localStorage.getItem('api_domain')+'/api/getProfileSSO?access_token='+localStorage.getItem('access_token'),{
                        method: 'post'
                    })
                    .then(res => res.json())
                    .then(
                    (result) => {
                        // console.log(JSON.stringify(result));
                        result.email = result.username;
                        result.bidang_studi_id = result.kode_wilayah.trim();
                                
                        localStorage.setItem('user', JSON.stringify(result));
                        window.location.href="/";
                    });
                }
    
            }
        }
    }

    handleClickShowPassword = () => {
        this.setState({
            showPassword: !this.state.showPassword
        })
    }

    handleMouseDownPassword = (event) => {
        event.preventDefault();
    }

    onSubmit = (model) => {
        // alert('oke');return true;
        // console.log(this.props.loading_besar);
        // this.props.setLoadingBesar(true);
        // this.props.submitLogin(model);
        // console.log('nendang');
        // console.log(model);
        this.setState({
            routeParams:{
                ...this.state.routeParams,
                email: model.email,
                password: model.password
            },
            loading_besar: true
        },()=>{
            // console.log('nendang');
            this.props.login(this.state.routeParams).then((result)=>{
                // console.log('nendang');
                // this.props.setLoadingBesar(false);
                // console.log(this.props.hasil_login);
                localStorage.setItem('jwt_token', this.props.hasil_login.token);

                // console.log(this.props.hasil_login);
                // console.log(this.props.hasil_login);
                console.log(Number(this.props.hasil_login.jumlah));

                // alert(JSON.stringify(this.props.hasil_login));return true;

                if(Number(this.props.hasil_login.jumlah) > 0){
                    console.log('passed this');                // if(typeof(this.props.hasil_login.user) !== 'undefined'){

                    if(this.props.hasil_login.token === null){
                        console.log('passed this');
                        // // user berganda
                        console.log(this.props.hasil_login.user_ganda);
                        // return true;

                        let checked = [];

                        for (let index = 0; index < this.props.hasil_login.user_ganda.length; index++) {
                            const element = this.props.hasil_login.user_ganda[index];
                            
                            checked[element.pengguna_id] = false;
                        }

                        this.setState({
                            ...this.state,
                            loading_besar: false,
                            pesan_ganda: true,
                            pesan_kesalahan: false,
                            pilihanGanda: checked
                        },()=>{
                            console.log(this.state.pilihanGanda);
                        });

                    }else{
                        console.log('passed this');
                        localStorage.setItem('user', JSON.stringify(this.props.hasil_login.user));
    
                        // console.log(localStorage.getItem('user'));
    
                        this.setState({
                            ...this.state,
                            loading_besar: false
                        },()=>{
                            window.location.href="/";
                        });
                    }
                }else{
                    console.log('passed this');
                    this.setState({
                        ...this.state,
                        loading_besar: false,
                        pesan_kesalahan: true
                    });
                }



                // this.setState({
                //     loading_besar: false
                // },()=>{
                // fetch(localStorage.getItem('api_domain')+'/api/AuthPengguna?token='+localStorage.getItem('jwt_token'),{
                //     method: 'GET'
                // })
                // .then(res => res.json())
                // .then(
                // (result) => {
                    // console.log(result);
                    // if(typeof(result.user) !== 'undefined'){
                    //     localStorage.setItem('user', JSON.stringify(result.user));

                    //     // console.log(localStorage.getItem('user'));

                    //     this.setState({
                    //         ...this.state,
                    //         loading_besar: false
                    //     },()=>{
                    //         window.location.href="/";
                    //     });
                    // }else{
                    //     this.setState({
                    //         ...this.state,
                    //         loading_besar: false,
                    //         pesan_kesalahan: true
                    //     });
                    // }
                // });
                    // window.location.href="/";
                // })
            }).catch((response) => {
                // console.log(response);
                //handle error
                // alert('pengguna tidak ditemukan');
                // console.log(response);
                this.setState({
                    loading_besar: false,
                    pesan_kesalahan: true
                });
            });
        })
    };

    handleChange = (e) => (key) => {
        this.setState({
            routeParams: {
                [key] : e.target.value
            }
        },()=>{
            console.log(this.state);
        })
    }

    checkboxTerpilih = (pengguna_id) => (event, checked) => {

        let tmpPilihanGanda = {};
        for (var prop in this.state.pilihanGanda) {
            // console.log(prop);
            tmpPilihanGanda[prop] = false;
        }

        // console.log(tmpPilihanGanda);
        tmpPilihanGanda[pengguna_id] = checked;
        
        this.setState({
            pilihanGanda:{
                ...tmpPilihanGanda
            }
        },()=>{
            console.log(this.state.pilihanGanda);
        })
    }

    hapusDataGanda = () => {
        
    }

    render()
    {
        const {classes} = this.props;
        const {canSubmit} = this.state;

        return (
            <div className={classNames(classes.root, "w-full flex flex-col flex-1 p-16 sm:p-0 md:flex-row justify-center konten-utama")} style={{marginBottom:'0px',width:'100%', backgroundImage:'linear-gradient(to left, rgb(51 119 42) 0%, rgb(19 128 23) 100%)'}}>
            {/* <div style={{width: '100%'}} className={classNames(classes.root, "w-full flex flex-col flex-1 p-16 sm:p-0 md:flex-row justify-center konten-utama")} style={{marginBottom:'0px',width:'100%', backgroundImage:'linear-gradient(-20deg, #b721ff 0%, #21d4fd 100%)'}}> */}
                <Dialog
                    // open={true}
                    open={this.state.loading_besar}
                >
                    <DialogContent id="loading-dialog" style={{textAlign: 'center'}}>
                        <CircularProgress className={classes.progress} style={{height:60, width:60, marginLeft:'20px', marginRight:'20px'}}/>
                        <br/>
                        Memroses...
                    </DialogContent>
                </Dialog>
                <Dialog
                    // open={true}
                    open={this.state.pesan_kesalahan}
                >
                    <DialogContent style={{background:'#ff8a80',color:'black', textAlign: 'center'}} id="error-dialog">
                        Pengguna tidak ditemukan atau password salah. Mohon cek kembali informasi pengguna Anda!
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={()=>{
                                this.setState({
                                    pesan_kesalahan: false
                                })
                            }}
                        >Tutup</Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    // open={true}
                    open={this.state.pesan_berhasil}
                >
                    <DialogContent style={{background:'white',color:'black', textAlign: 'center'}} id="error-dialog">
                        Proses berhasil. Silakan login kembali menggunakan akun yang telah Anda pilih
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={()=>{
                                this.setState({
                                    pesan_berhasil: false,
                                    loading_besar: false
                                })
                            }}
                        >Tutup</Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    // open={true}
                    open={this.state.pesan_gagal}
                >
                    <DialogContent style={{background:'#eeeeee',color:'black', textAlign: 'center'}} id="error-dialog">
                        Proses gagal. Silakan coba beberapa saat lagi.
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={()=>{
                                this.setState({
                                    pesan_gagal: false
                                })
                            }}
                        >Tutup</Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    // open={true}
                    open={this.state.pesan_tidak_ada_yang_dipilih}
                >
                    <DialogContent style={{background:'#ff8a80',color:'black', textAlign: 'center'}} id="error-dialog">
                        Mohon pilih salah satu pengguna terlebih dahulu!
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={()=>{
                                this.setState({
                                    pesan_tidak_ada_yang_dipilih: false
                                })
                            }}
                        >Tutup</Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    // open={true}
                    open={this.state.pesan_ganda}
                >
                    <DialogTitle>
                        Pengguna Ganda dengan Email yang sama
                    </DialogTitle>
                    <DialogContent>
                        Terdapat dua atau lebih pengguna dengan email yang sama pada aplikasi Anda. Silakan pilih (ceklis) pengguna yang akan Anda gunakan. Pengguna yang tidak Anda pilih (tidak diceklis) akan dihapus dari aplikasi.
                        <br/>
                        <List>
                            {this.props.hasil_login.user_ganda.map((option)=>{
                                return (
                                    <ListItem>
                                        {/* <Grid>
                                            <Grid item xs={2}>

                                            </Grid>
                                            <Grid item xs={10}>
                                                
                                            </Grid>
                                        </Grid> */}
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={this.state.pilihanGanda[option.pengguna_id]}
                                                    onChange={this.checkboxTerpilih(option.pengguna_id)}
                                                    name={"pengguna_ganda"}
                                                    key={option.pengguna_id}
                                                    color="primary"
                                                    inputProps={{
                                                        email: option.email
                                                    }}
                                                    disabled={false}
                                                />
                                            }
                                            // label={option.nama + " (" + option.email + ") - Pembaruan Terakhir: " + option.last_update}
                                            label={<span>
                                                {option.nama} ({option.email})<br/>
                                                Aktif: <b>{(option.soft_delete === 0 ? 'Aktif' : 'Tidak Aktif')}</b><br/>
                                                Peran: <b>{(option.peran_id === 10 ? 'Kepsek (Ops)' : (option.peran_id === 53 ? 'Guru' : (option.peran_id === 90 ? 'Peserta Didik' : (option.peran_id === 14 ? 'Komite Sekolah' : '-'))))}</b><br/>
                                                Pembaruan Terakhir: {option.last_update}<br/>
                                                Status: <b style={{color:(this.state.pilihanGanda[option.pengguna_id] === true ? 'green' : 'red')}}>{(this.state.pilihanGanda[option.pengguna_id] === true ? 'Pengguna yang digunakan' : 'Pengguna yang akan dihapus')}</b>
                                            </span>}
                                            // className="wadahSelect"
                                        />
                                    </ListItem>
                                )
                            })}
                        </List>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant="raised"
                            onClick={()=>{
                                let yangDipilih = 0;

                                for (const key in this.state.pilihanGanda) {
                                    if (this.state.pilihanGanda.hasOwnProperty(key)) {
                                        const element = this.state.pilihanGanda[key];
                                        
                                        if(element === true){
                                            yangDipilih++;
                                        }
                                    }
                                }

                                if(yangDipilih < 1){
                                    // alert('Mohon pilih salah satu pengguna terlebih dahulu!');
                                    this.setState({
                                        pesan_tidak_ada_yang_dipilih: true
                                    });

                                    return false;
                                }else{

                                    this.setState({
                                        pesan_ganda: false,
                                        loading_besar: true,
                                        routeParams: {
                                            ...this.state.routeParams,
                                            data: this.state.pilihanGanda
                                        }
                                    },()=>{
                                        
                                        this.props.hapusPenggunaGanda(this.state.routeParams).then((result)=>{
                                            if(result.payload > 0){
                                                this.setState({
                                                    pesan_berhasil: true,
                                                    loading_besar: false
                                                });
                                            }else{
                                                this.setState({
                                                    pesan_gagal: true,
                                                    loading_besar: false
                                                });
                                            }
                                        });
                                        
                                    });
                                    
                                }
                            }}
                        >Gunakan yang terpilih(terceklis), Hapus yang tidak terpilih</Button>
                    </DialogActions>
                </Dialog>
                <Hidden smDown>
                    <div className="relative flex flex-col flex-no-grow items-center justify-center text-white p-16 text-center md:p-128 md:items-start md:flex-no-shrink md:flex-1 md:text-left">
                        {/* <FuseAnimate animation="transition.expandIn"> */}
                        <img className="mb-16" src="/assets/images/logos/logopmp.png" alt="logo" style={{width:'128px', height:'128px', marginTop:'-100px'}} />
                        {/* </FuseAnimate> */}
                        <FuseAnimate animation="transition.slideUpIn" delay={300}>
                            <div>
                                <Typography variant="display1" color="inherit" className="font-light font-bold uppercase">
                                    {localStorage.getItem('judul_aplikasi')}
                                </Typography>
                                <Typography variant="display2" color="inherit" className="font-light" style={{fontSize:'30px'}}>
                                    {localStorage.getItem('bos_aplikasi')}
                                </Typography>
                                <Typography variant="body2" color="inherit" className="text-grey-ligther">
                                    {localStorage.getItem('badan_aplikasi')}
                                </Typography>
                                <Typography variant="display1" color="inherit" className="font-light">
                                    <i style={{color:'yellow'}}>versi OFFLINE</i> <i style={{color:'yellow'}}>{localStorage.getItem('versi_app')}</i>
                                </Typography>
                            </div>

                        </FuseAnimate>
                        <br/>
                        <br/>
                        <FuseAnimate animation="transition.slideUpIn" delay={300} >
                            <Grid container style={{position: 'fixed', bottom:'0px'}}>
                                <Grid item xs={2} sm={1} style={{border:'0px solid red'}}>
                                    <img className="mb-16" src="/assets/images/logos/logo_dapodik.png" alt="logo" style={{width:'60px'}} />
                                </Grid>
                                <Grid item xs={10} sm={11} style={{border:'0px solid red', paddingTop:'10px'}}>
                                    Terintegrasi dengan
                                    <br/>
                                    <b style={{fontSize:'20px'}}>Dapodik</b>
                                </Grid>
                            </Grid>
                        </FuseAnimate>
                        <br/>
                        {/* <FuseAnimate animation="transition.slideUpIn" delay={300} > */}
                        <img className="mb-16" src="/assets/images/hardiknas2020.png" alt="logo" width={100} />
                        <br/>
                        <div style={{fontSize:'20px', marginTop:'-30px', fontStyle:'italic'}}>"Belajar dari Covid-19"</div>
                        {/* <div style={{fontSize:'20px', marginTop:'-30px', fontStyle:'italic'}}></div> */}
                            {/* <Grid container style={{position: 'fixed', bottom:'0px'}}>
                                <Grid item xs={4} sm={1} style={{border:'0px solid red'}}>
                                </Grid>
                                <Grid item xs={10} sm={11} style={{border:'0px solid red', paddingTop:'10px'}}>
                                    Terintegrasi dengan
                                    <br/>
                                    <b style={{fontSize:'20px'}}>Dapodik</b>
                                </Grid> 
                            </Grid> */}
                        {/* </FuseAnimate> */}
                    </div>
                </Hidden>
                {/* <FuseAnimate animation={{translateX: [0, '100%']}}> */}
                    <Card style={{maxWidth:'400px', height:'100%'}} className="flex flex-col items-center justify-center w-full mx-auto m-16 md:m-0 rounded-8 sm:rounded-none" square>
                        <CardContent className="w-full p-16 sm:p-32">
                            <Hidden smUp>
                                <div className="flex flex-col flex-no-grow items-center justify-center text-white mb-24 text-center md:p-128 md:items-start md:flex-no-shrink md:flex-1 md:text-left">
                                    <FuseAnimate animation="transition.expandIn">
                                        <img className="w-80 mb-16" src="/assets/images/logos/logopmp.png" alt="logo" />
                                    </FuseAnimate>
                                    <FuseAnimate animation="transition.slideUpIn" delay={300}>
                                        <div>
                                            <Typography variant="h4" color="primary" className="font-bold uppercase text-18">
                                                {localStorage.getItem('judul_aplikasi')}
                                            </Typography>
                                            <Typography variant="h5" color="inherit" className="text-grey-darkest text-14">
                                                {localStorage.getItem('bos_aplikasi')}
                                            </Typography>
                                            {/* <Typography variant="h5" color="inherit" className="text-grey-darkest text-14">
                                                OFFLINE
                                            </Typography> */}
                                        </div>
                                    </FuseAnimate>
                                </div>
                            </Hidden>
                            <Typography variant="h6" className="font-bold text-center uppercase md:w-full mb-48 hidden sm:block" color="primary">
                                MASUK {localStorage.getItem('judul_aplikasi')} versi {localStorage.getItem('versi_app')}
                            </Typography>
                            <div className="w-full">
                                <Formsy
                                    onValidSubmit={this.onSubmit}
                                    onValid={this.enableButton}
                                    onInvalid={this.disableButton}
                                    ref={(form) => this.form = form}
                                    className="flex flex-col justify-center w-full"
                                >
                                    {/* <div style={{padding:'8px', border:'1px dashed #ccc'}}> */}
                                    <TextFieldFormsy
                                        className="mb-16"
                                        type="text"
                                        name="email"
                                        label="Email"
                                        validations={{
                                            minLength: 4
                                        }}
                                        validationErrors={{
                                            minLength: 'Minimal 4 Karakter'
                                        }}
                                        // InputProps={{
                                        //     endAdornment: <InputAdornment position="end"><Icon className="text-20" color="action">email</Icon></InputAdornment>
                                        // }}
                                        variant="outlined"
                                        required
                                        // onChange={this.handleChange('email')}
                                    />
                                    <TextFieldFormsy
                                        className="mb-16"
                                        type={this.state.showPassword ? 'text' : 'password'}
                                        name="password"
                                        label="Kata Sandi"
                                        validations={{
                                            minLength: 4
                                        }}
                                        validationErrors={{
                                            minLength: 'Minimal 4 Karakter'
                                        }}
                                        // InputProps={{
                                        //     endAdornment: <InputAdornment position="end"><Icon className="text-20" color="action">vpn_key</Icon></InputAdornment>
                                        // }}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">
                                            <IconButton
                                              aria-label="toggle password visibility"
                                              onClick={this.handleClickShowPassword}
                                              onMouseDown={this.handleMouseDownPassword}
                                            >
                                              {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                          </InputAdornment>
                                        }}
                                        variant="outlined"
                                        required
                                        // endAdornment={
                                        //     <InputAdornment position="end">
                                        //       <IconButton
                                        //         aria-label="toggle password visibility"
                                        //         onClick={this.handleClickShowPassword}
                                        //         onMouseDown={this.handleMouseDownPassword}
                                        //       >
                                        //         {this.state.showPassword ? <VisibilityOff /> : <VisibilityOff />}
                                        //       </IconButton>
                                        //     </InputAdornment>
                                        //   }
                                        // onChange={this.handleChange('password')}
                                    />
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        className="w-full mx-auto mt-16 normal-case relative"
                                        aria-label="Masuk"
                                        disabled={!canSubmit}
                                        value="legacy"
                                    >
                                        Masuk
                                    </Button>
                                    {/* </div> */}
                                    {Number(localStorage.getItem('online')) === 1 && Number(localStorage.getItem('tipe_app')) === 1 &&
                                    <div>
                                    <br/>
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="secondary"
                                        className="w-full mx-auto mt-16 normal-case relative"
                                        aria-label="Login Dengan SSO Dapodik"
                                        value="legacy"
                                        onClick={()=>window.location.href = 'https://data.dikdasmen.kemdikbud.go.id/sso/auth?response_type=code&client_id=pmp2019&state=300300&redirect_uri=http://pmp.dikdasmen.kemdikbud.go.id:1745'}
                                        >
                                        Login dengan SSO Dapodik
                                    </Button>
                                    </div>
                                    }
                                    <br/>
                                    <br/>
                                    {Number(localStorage.getItem('online')) !== 1 &&
                                    <div style={{padding:'16px', border:'1px dashed #ccc', borderRadius:'8px'}}>
                                        <Typography variant="title" style={{color:'#434343', textAlign: 'center'}}>Registrasi</Typography>
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            color="secondary"
                                            className="w-full mx-auto mt-16 normal-case relative"
                                            aria-label="Registrasi"
                                            value="legacy"
                                            style={{background:'teal'}}
                                            onClick={()=>this.props.history.push('/registrasiDapodik')}
                                            >
                                            Registrasi dengan Dapodik Lokal
                                        </Button>
                                        <br/>
                                        <br/>
                                        <Typography variant="subtitle" style={{color:'#434343', textAlign: 'center'}}>Atau</Typography>
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            color="secondary"
                                            className="w-full mx-auto mt-16 normal-case relative"
                                            aria-label="Registrasi"
                                            value="legacy"
                                            onClick={()=>this.props.history.push('/registrasi')}
                                            >
                                            Registrasi dengan Prefill
                                        </Button>
                                        <br/>
                                        <br/>
                                        <Paper className="p-8">
                                            <Typography variant="caption" style={{color:'#434343', fontSize:'10px', fontStyle:'italic'}}>
                                                Mohon hanya pilih satu metode registrasi! Proses registrasi menggunakan lebih dari satu metode akan mengakibatkan ketidaksesuaian pada data sekolah Anda!
                                            </Typography>
                                        </Paper>
                                    </div>
                                    }
                                </Formsy>
                            </div>
                        </CardContent>
                    </Card>
                {/* </FuseAnimate> */}
                
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getPengguna: Actions.getPengguna,
        tukarPengguna: Actions.tukarPengguna,
        getPeran: Actions.getPeran,
        setFeedback: Actions.setFeedback,
        setLoading: Actions.setLoading,
        setLoadingBesar: Actions.setLoadingBesar,
        setHasilFeedback: Actions.setHasilFeedback,
        setJudul: Actions.setJudul,
        login: Actions.login,
        hapusPenggunaGanda: Actions.hapusPenggunaGanda
    }, dispatch);
}

function mapStateToProps({ Pengguna, App }) {

    return {
        pengguna: Pengguna.pengguna,
        hasil_tukar_pengguna: Pengguna.hasil_tukar_pengguna,
        hasil_simpan_feedback: App.hasil_simpan_feedback,
        loading: App.loading,
        peran: Pengguna.peran,
        loading_besar: App.loading_besar,
        hasil_login: App.hasil_login
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(Login)));



// WEBPACK FOOTER //
// ./src/main/content/login/Login.js